<template>
  <div
    class="xl:w-4/5 md:w-11/12 xl:my-10 md:my-4
     md:mx-auto m-1 bg-gray-50 rounded"
  >
    <div class="flex flex-row justify-center p-4 w-full">
      <h1 class="font-semibold xl:text-xl ">Data Upload</h1>
    </div>

    <div class="p-4 w-auto">
      <t-alert variant="info" show v-on:hidden="setCookie" v-if="noCookie()">
        Upload CSV Files to popopulate the database. Existing tables will be
        dropped and may cascade, consider saving making a backup ('download
        CSV's').
        <br />
        The CSV files tested have been auto-generated
        <a
          class="underline text-blue-900"
          href="https://www.jetbrains.com/help/datagrip/export-data-in-ide.html"
        >
          in our database software, with option 'add column header'
        </a>
        the source database has been cloned from:
        <a
          class="underline text-blue-900"
          href="https://gitlab.cim.rhul.ac.uk/uxac009/coursedb"
          >https://gitlab.cim.rhul.ac.uk/uxac009/coursedb</a
        >
        (commit
        <a
          class="underline text-blue-900"
          href="https://gitlab.cim.rhul.ac.uk/uxac009/coursedb/-/commit/f593184eff785ca757590e023674192a0187d35e "
          >f593184eff785ca757590e023674192a0187d35e</a
        >) .
        <br />
        With the addition of 'module_requests' (optional).
        <br />
        Example CSV files are available on the project github and can also be
        found in the project base directory. The actual database used in this
        project is a trimmed down version of the above, the example CSVs assume
        a superset of columns.
        <br />
        If the CSV has more columns than the coresponding table, then the extra
        columns will be dropped. If too few columns are present those fields
        will be null. Consider inspecting the database to ensure the changes
        propegated as expected.
        <br />
        <span class="text-blue-900">Accepted CSV names:</span>
        <br />
        {{ csvNames.map((el) => el + '.csv') }}
      </t-alert>
    </div>
    <div class="px-8">
      <div class="p-1">
        <t-button @click="download">Download CSV's</t-button>
      </div>
      <h1 class="p-1 font-semibold">Delete all rows from table (foreign
      key checks disabled):</h1>
      <div class="flex flex-wrap">
        <div v-for="item in csvNames" :key="item.key" class="p-1">
          <t-button class="p-4" variant="error" @click="drop_table(item)">{{
            item
          }}</t-button>
        </div>
      </div>
      <h1 class="p-1 font-semibold">Upload CSV:</h1>
    </div>
    <Upload :csvName="csvNames" />
  </div>
</template>

<script>
import Upload from './Upload';
export default {
  components: {Upload},
  data() {
    return {
      csvNames: [
        'leaders',
        'module_choices',
        'module_option_keys',
        'modules',
        'module_crns',
        'option_rules',
        'people',
        'programme_option_keys',
        'programmes',
        'strands',
        'ldap_overrides',
      ],
    };
  },
  methods: {
    download() {
      fetch(
        `${process.env.VUE_APP_API_URL}/generate_CSVs`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: localStorage.getItem('jwt'),
          }),
        },
      )
        .then((res) => res.blob())
        .then((blob) => {
          const file = window.URL.createObjectURL(blob);
          window.location.assign(file);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    setCookie() {
      this.$cookies.set('CSV-infobox', 'dismissed', 'infinity');
    },
    noCookie() {
      return !(this.$cookies.get('CSV-infobox') === 'dismissed');
    },
    drop_table(item) {
      this.$dialog
        .confirm(`Delete ${item}?`, 'This action cannot be undone.', 'info')
        .then((result) => {
          if (result.hideReason === 'ok') {
            fetch(
              `${process.env.VUE_APP_API_URL}/drop_table`,
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  table: item,
                  jwt: localStorage.getItem('jwt'),
                })
              },
            )
              .then((response) => {
                console.log(response);
              })
              .catch((err) => {
                console.error(err);
              });
          }
        });
    },
  },
};
</script>

<style></style>
